export var AdminType;
(function (AdminType) {
    AdminType["SUPER_ADMIN"] = "SUPER_ADMIN";
    AdminType["TENANT_ADMIN"] = "TENANT_ADMIN";
})(AdminType || (AdminType = {}));
//# sourceMappingURL=admin-type.enum.js.map